module.exports = __webpack_public_path__ + "img/company_logo_navbar.473bf881.png";